import React from 'react';
import { Clock, User, FileText, Shield, Database } from 'lucide-react';

interface ActividadReciente {
  id: string;
  usuario: string;
  accion: string;
  recurso: string;
  timestamp: Date;
}

interface ActivityLogProps {
  actividades: ActividadReciente[];
}

const ActivityLog: React.FC<ActivityLogProps> = ({ actividades }) => {
  // Ordenar actividades por fecha (más recientes primero)
  const actividadesOrdenadas = [...actividades].sort((a, b) => 
    b.timestamp.getTime() - a.timestamp.getTime()
  );

  // Función para obtener el icono según la acción
  const getActionIcon = (accion: string) => {
    if (accion.includes('sesión')) return <User className="h-4 w-4 text-cyber-blue" />;
    if (accion.includes('credenciales')) return <Shield className="h-4 w-4 text-cyber-warning" />;
    if (accion.includes('política') || accion.includes('seguridad')) return <Shield className="h-4 w-4 text-cyber-safe" />;
    if (accion.includes('Base de datos') || accion.includes('backup')) return <Database className="h-4 w-4 text-cyber-blue" />;
    if (accion.includes('amenaza') || accion.includes('bloqueo')) return <Shield className="h-4 w-4 text-cyber-alert" />;
    return <FileText className="h-4 w-4 text-cyber-light" />;
  };

  // Función para formatear la hora
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-cyber-dark-blue bg-opacity-80 backdrop-blur-md p-4 rounded-lg border border-cyber-blue/30">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center">
        <Clock className="h-5 w-5 mr-2 text-cyber-blue" />
        Registro de Actividad
      </h3>
      
      <div className="space-y-1 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
        {actividadesOrdenadas.map((actividad) => (
          <div 
            key={actividad.id}
            className="p-2 rounded-lg border border-cyber-gray/20 bg-cyber-gray/10 hover:bg-cyber-gray/20 transition-all duration-200"
          >
            <div className="flex items-center gap-3">
              <div className="flex-shrink-0">
                {getActionIcon(actividad.accion)}
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-sm text-white">
                      <span className="font-medium text-cyber-blue">{actividad.usuario}</span>
                      <span className="mx-1">·</span>
                      <span>{actividad.accion}</span>
                    </p>
                    <p className="text-xs text-cyber-light truncate">
                      {actividad.recurso}
                    </p>
                  </div>
                  
                  <span className="text-xs text-cyber-light ml-2">
                    {formatTime(actividad.timestamp)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-3 text-center">
        <button className="text-xs text-cyber-blue hover:text-cyber-blue/80 transition-colors">
          Ver historial completo
        </button>
      </div>
    </div>
  );
};

export default ActivityLog;